<template>
    <div class="bg-title text-left d-center-start mt-5 border">
      <i class="iconfont text-warning h1 mr-3" :class="subIcon" />
      <p class="font-weight-bold">{{subTitle}}</p>
    </div>
</template>

<script>
    export default {
      name: 'ItemTitle',
      props:['sub-title','sub-icon']
    }
</script>

<style scoped lang="scss">
.bg-title{
  padding: 10px;
  border-radius: 5px 5px 0 0;
  background: #fcfcfc;
}
</style>
